export default __webpack_public_path__ + "static/media/4.e82d20cb.png";